import { render } from "./YourDetailsBanner.vue?vue&type=template&id=30bc7131&scoped=true"
import script from "./YourDetailsBanner.vue?vue&type=script&lang=js"
export * from "./YourDetailsBanner.vue?vue&type=script&lang=js"

import "./YourDetailsBanner.vue?vue&type=style&index=0&id=30bc7131&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src39322066/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bc7131"]])

export default __exports__